/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ISpacerViewProps } from './spacer';

const SpacerView: React.FC<ISpacerViewProps> = props => {
    const child = props.config.divider && <hr className={'ms-spacer__divider'} />;

    return (
        <div className={props.className} id={props.id} {...props.renderModuleAttributes(props)}>
            {child}
        </div>
    );
};

export default SpacerView;
